import { addEmployee } from "directus/src/operations";

export async function createUser({ item }) {
  try {
    const data = await addEmployee(item);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
